var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDiscrete = function SvgDiscrete(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    width: 16,
    height: 16,
    viewBox: "0 0 4.233 4.233",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -292.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect4496",
    fill: "currentColor",
    d: "M2.998 295.16v.53h1.107v-.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4498",
    fill: "currentColor",
    d: "M1.331 293.89v.53h1.76v-.53z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5204",
    width: 0.531,
    height: 1.79,
    x: 19.265,
    y: 292.25,
    fill: "currentColor",
    rx: 0.201,
    ry: 0.271,
    transform: "matrix(.99365 .11249 -.06153 .99811 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4496-5",
    fill: "currentColor",
    d: "M.114 295.16v.53h1.29v-.53z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5206-3",
    strokeWidth: 0.894,
    transform: "matrix(-.99653 .11281 .10406 1.688 -19.793 -202.42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect5204-0",
    width: 0.529,
    height: 1.058,
    x: 7.529,
    y: 293.5,
    fill: "currentColor",
    rx: 0.2,
    ry: 0.16
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDiscrete);
export default ForwardRef;